module.exports = __webpack_public_path__ + "fonts/RenaultLife-BoldItalic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-BoldItalic.svg
// module id = 354
// module chunks = 0